import React from "react";
import classes from "./heading.module.css";

const Heading = ({ heading, className, style = {} }) => {
  return  <h2 className={classes.heading}>{heading} </h2>;
};

export default Heading;
